import { Flex, Text, AccordionButton } from '@chakra-ui/react';

import { ArrowDownSLineIcon, ArrowUpSLine } from '@/components/Icons';

import { FC, PropsWithChildren } from 'react';

type FilterItemsGroupNameProps = PropsWithChildren & {
  isExpanded?: boolean;
};
const FilterItemsGroupName: FC<FilterItemsGroupNameProps> = ({ isExpanded, children }) => {
  return (
    <AccordionButton
      as={Flex}
      w="100%"
      p="0"
      gap="0.5rem"
      justifyContent="space-between"
      alignItems="center"
      cursor="pointer"
      _hover={{}}
    >
      <Text
        as="span"
        textTransform="capitalize"
        fontSize="0.875rem"
        color="primary.200"
      >
        {children}
      </Text>
      {isExpanded ? (
        <ArrowUpSLine size="1rem" />
      ) : (
        <ArrowDownSLineIcon size="1rem" />
      )}
    </AccordionButton>
  );
};

export default FilterItemsGroupName;
